import SourceFlowImage from "@sourceflow-uk/sourceflowimage";
import { Container, Card } from 'reactstrap';
import Link from "next/link";
import styles from './styles.module.scss';
import { Swiper, SwiperSlide } from 'swiper/react';
import { Pagination, Navigation, Autoplay } from "swiper";
import useAwardsIndustryRecognition from '@/hooks/useAwardsIndustryRecognition';

import 'swiper/css';
import 'swiper/css/navigation';
import 'swiper/css/pagination';
import 'swiper/css/autoplay';

export const Awards = ({
    className,
    title,
    heading,
    heading_center,
    selectedItems,
}) => {

    const items = useAwardsIndustryRecognition();
    
    const filteredItems = selectedItems?.length > 0 ? items.filter((item) => selectedItems?.includes(item?.id)) : items;

    if (!filteredItems || !filteredItems.length > 0) {
        return null;
    }

    const settings = {
        modules: [Navigation, Pagination, Autoplay],
        loop: false,
        spaceBetween: 30,
        slidesPerView: 7,
        speed: 400,
        autoplay: {
            delay: 3000,
        },
        pagination: {
            clickable: true,
            el: `.swiper-custom-paginations .awardsSwiper`,
        },
        navigation: {
            nextEl: `.awardsSwiper.swiper-next`,
            prevEl: `.awardsSwiper.swiper-prev`
        },
        breakpoints: {
            1200: {
                slidesPerView: 7,
            },
            991: {
                slidesPerView: 3,
            },
            767: {
                slidesPerView: 2,
            },
            300: {
                slidesPerView: 2,
            }
        }
    }
    return (
        <section className={`${styles.root} ${className} overflow-hidden`}>
            <Container>
                {title &&
                    <div className="mb-5">
                        <h2 className={`${heading} ${heading_center ? 'text-center' : ''}`}>{title}</h2>
                    </div>
                }
                <div>
                    <Swiper {...settings}>
                        {filteredItems.map((item, index) => (
                            <SwiperSlide key={index}>
                                <Card key={index} className="rounded-0 bg-transparent border-0 align-items-center">
                                    {item?.link ?
                                        <Link href={`${item?.link}`}>
                                            <a title={`${item?.title}`}>
                                                <SourceFlowImage
                                                    src={item?.image}
                                                    size="500x"
                                                    alt={item?.title}
                                                    width="100%"
                                                    height="100%"
                                                    className="card-img rounded-0 m-auto"
                                                />
                                            </a>
                                        </Link>
                                    :
                                        <SourceFlowImage
                                            src={item?.image}
                                            size="500x"
                                            alt={item?.title}
                                            width="100%"
                                            height="100%"
                                            className="card-img rounded-0 m-auto"
                                        />
                                    }
                                </Card>
                            </SwiperSlide>
                        
                        ))}
                    </Swiper>
                </div>
                <div className="text-center swiper-custom-paginations mt-4">
                    <div className={`awardsSwiper`} />
                </div>
            </Container>
        </section>
    )
}

export default Awards;
